// Gemeinsamer Briefkopf/-fuß für Lieferschein & Rechnung – Format Gluty-Free Club.
// Werte kommen aus settings.company (editierbar), mit Fallback auf die Marken-Defaults.
// Belegschrift: Fira Sans (bereits global über index.css geladen) — bewusst dieselbe Schrift wie
// in der App, damit Bildschirm und Druck identisch aussehen.
export const LUCIDA = { fontFamily: "'Fira Sans', 'Segoe UI', system-ui, sans-serif" };

const DEF = {
  website: "www.glutyfreeclub.com",
  email: "hello@glutyfreeclub.com",
  city: "Hamburg",
  sender_line: "Consberry GmbH – Wulfsdorfer Weg 121 · 22359 Hamburg",
  footer_brand: "Gluty-Free Club is powered by Consberry GmbH",
  office_address: "Hoheluftchaussee 40a · 20253 Hamburg",
  managing_director: "Arne Mentz",
  bank_name: "Commerzbank AG",
  iban: "DE91 2004 0000 0401 2076 00",
  bic: "COBADEFFXXX",
  register: "HRB 92710 Amtsgericht Hamburg",
  vat_id: "DE 239478276",
};

export const senderLine = (company) => (company?.sender_line || DEF.sender_line);

// Entfernt eine führende Namenszeile aus der Adresse, wenn sie exakt dem Empfängernamen
// entspricht (verhindert doppelten Namen, z. B. bei Shopify/B2C-Adressen). Greift bei
// zeilen- und kommagetrennten Adressen; lässt B2B-Adressen ohne Namenszeile unverändert.
export const stripLeadingName = (address, name) => {
  const addr = (address || "").trim();
  const nm = (name || "").trim().toLowerCase();
  if (!addr || !nm) return addr;
  const nlLines = addr.split(/\r?\n/);
  if ((nlLines[0] || "").trim().toLowerCase() === nm) return nlLines.slice(1).join("\n").trim();
  const parts = addr.split(",").map((s) => s.trim());
  if (parts.length > 1 && parts[0].toLowerCase() === nm) return parts.slice(1).join(", ").trim();
  return addr;
};

export const longDate = (s) => {
  try { return new Date(s).toLocaleDateString("de-DE", { weekday: "long", day: "numeric", month: "long", year: "numeric" }); }
  catch { return s; }
};

export function LetterHead({ logo, company }) {
  const c = company || {};
  return (
    <div className="flex justify-between items-start">
      <div>
        {logo
          ? <img src={logo} alt="Gluty-Free Club" className="h-20 w-auto" data-testid="letter-logo" />
          : <div className="leading-none" style={{ color: "#B8860B" }}>
              <div className="text-3xl font-bold tracking-tight">GLUTY-FREE</div>
              <div className="text-2xl font-semibold italic -mt-1">Club</div>
            </div>}
      </div>
      <div className="text-right text-xs text-neutral-700 leading-5">
        <div>{c.website || DEF.website}</div>
        <div>{c.email || DEF.email}</div>
        <div className="font-bold text-sm mt-1.5">{c.city || DEF.city}</div>
      </div>
    </div>
  );
}

export function LetterFooter({ company, extra }) {
  const c = company || {};
  const lines = [
    c.footer_brand || DEF.footer_brand,
    `Büroanschrift: ${c.office_address || DEF.office_address}   |   Geschäftsführung: ${c.managing_director || DEF.managing_director}`,
    `${c.bank_name || DEF.bank_name} · IBAN ${c.iban || DEF.iban} · BIC ${c.bic || DEF.bic}`,
    `Umsatzsteuer-ID Nr.: ${c.vat_id || DEF.vat_id}   |   ${c.register || DEF.register}`,
  ];
  return (
    <div className="mt-16 pt-3 border-t border-neutral-200 text-center text-[10px] text-neutral-500 leading-4" data-testid="letter-footer">
      {lines.map((l) => <div key={l}>{l}</div>)}
      {extra && <div className="mt-1">{extra}</div>}
    </div>
  );
}
